import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface ScribeEmbedProps {
  src: string;
  title: string;
  description?: string;
  height?: string;
}

export const ScribeEmbed: React.FC<ScribeEmbedProps> = ({
  src,
  title,
  description,
  height = '500px',
}) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <div className="space-y-1">
          <CardTitle className="flex items-center gap-2">
            <span className="text-lg">📖</span>
            {title}
          </CardTitle>
          {description && (
            <CardDescription>{description}</CardDescription>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {hasError ? (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              Der Scribe-Guide konnte nicht geladen werden. Bitte öffnen Sie den Guide im neuen Tab.
            </AlertDescription>
          </Alert>
        ) : (
          <div className="relative w-full rounded-lg overflow-hidden border border-border">
            <iframe
              src={src}
              width="100%"
              height={height}
              style={{ minHeight: height, display: 'block' }}
              frameBorder="0"
              scrolling="yes"
              allowFullScreen
              onError={handleError}
              className="w-full bg-background"
              title={title}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};
